import { Icons } from '../icon'
import SystemLayout from './SystemLayout'
import { NavigationItemProps } from './NavigationMenu'
import Sidebar from './Sidebar'

const NAVIGATION_LINKS: NavigationItemProps[] = [
  {
    icon: Icons.Group,
    title: 'Miembros',
    description: 'Administra los usuarios que forman parte de la organización.',
    to: '/organization/members',
  },
  {
    icon: Icons.Grid,
    title: 'Departamentos',
    description: 'Gestiona tus departamentos, sus permisos y sus miembros.',
    to: '/organization/departments',
  },
  {
    icon: Icons.Info,
    title: 'Información',
    description:
      'Edita la información de la organización para que la IA pueda utilizarla.',
    to: '/organization/information',
  },
  {
    icon: Icons.Bill,
    title: 'Facturación',
    description: 'Edita los datos de facturación de tu empresa.',
    to: '/organization/billing-info',
  },
]

const OrganizationLayout = () => {
  return (
    <SystemLayout>
      <Sidebar
        title="Organización"
        subtitle="Configura tu organización"
        links={NAVIGATION_LINKS}
      />
    </SystemLayout>
  )
}

export default OrganizationLayout
